import { defineMessages } from "react-intl";

const ENTER_SECRET_QUESTION_ANSWER_FORM = "enter-secret-question-answer-form";

const enterSecretQuestionAnswerFormMessages = defineMessages({
  prompt: {
    id: `${ENTER_SECRET_QUESTION_ANSWER_FORM}.prompt`,
    defaultMessage:
      "Please answer the following question to verify your account.",
    description: "Header text to inform the user of the purpose of the form"
  },
  unableToVerifyAnswer: {
    id: `${ENTER_SECRET_QUESTION_ANSWER_FORM}.unable-to-submit-code`,
    defaultMessage: "Unable to verify your answer. Please try again later."
  },
  wrongAnswer: {
    id: `${ENTER_SECRET_QUESTION_ANSWER_FORM}.wrong-answer`,
    defaultMessage: "The answer you provided is incorrect.",
    description: "Text input error for when a code is incorrect or expired."
  }
});

export default enterSecretQuestionAnswerFormMessages;
